export const apiUrl = process.env.REACT_APP_API_URL;
export const appName =process.env.REACT_APP_APP_NAME;
export const baseUrl =process.env.REACT_APP_BASE_URL;